import { LengthUnits } from "convert-units";
import { formatUnitValue } from "../../lib/convert";
import { LabeledValue } from "../base/LabeledValue";

type CameraHeightProps = {
  value?: number;
  showLabels?: boolean;
  precision?: number;
  units?: LengthUnits;
};

const CameraHeightDisplay = ({
  value,
  showLabels = true,
  units,
  precision,
}: CameraHeightProps) => {
  let to = units;
  if (!to && value != undefined) {
    to = value > 1000 ? "km" : "m";
  }
  precision ??= to === "m" ? 1 : 3;
  return (
    <LabeledValue
      label={
        showLabels && (
          <>
            Height<sub>G</sub>
          </>
        )
      }
      value={formatUnitValue(value, {
        from: "m",
        to,
        precision,
        showUnits: true
      }) ?? "-"}
    />
  );
};

export default CameraHeightDisplay;
